export const URL = {
    LINKEDIN_URL: 'https://www.linkedin.com',
};
